import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Attempt } from "types";
import first from "lodash/first";
import { formatEligibleRecord } from "util/records";
import { useRecordAttempts } from "util/useRecordAttempts";

const RecordInfo = ({
  currentAttempt,
  id,
}: {
  currentAttempt: Attempt | undefined | null;
  id: string;
}) => {
  const allRecords = useRecordAttempts();

  const recordsForAttempt = currentAttempt
    ? allRecords?.[currentAttempt._id]
    : [];

  return (
    <DisplayComponent style={{ top: 138, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 22,
          padding: sizeMultiplier * 12,
          width: sizeMultiplier * 600,
        };

        let recordAttempt: React.ReactNode = "";
        if (currentAttempt?.worldRecord) {
          recordAttempt = <span>World Record Attempt</span>;
        } else if (currentAttempt?.regionalRecord) {
          recordAttempt = <span>Regional Record Attempt</span>;
        } else if (
          currentAttempt?.stateRecord &&
          currentAttempt?.americanRecord
        ) {
          recordAttempt = <span>State and American Record Attempt</span>;
        } else if (
          currentAttempt?.stateRecord &&
          currentAttempt?.nationalRecord
        ) {
          recordAttempt = <span>State and National Record Attempt</span>;
        } else if (currentAttempt?.stateRecord) {
          recordAttempt = <span>State Record Attempt</span>;
        } else if (currentAttempt?.americanRecord) {
          recordAttempt = <span>American Record Attempt</span>;
        } else if (
          currentAttempt?.provincialRecord &&
          currentAttempt?.canadianRecord
        ) {
          recordAttempt = <span>Canadian and Provincial Record Attempt</span>;
        } else if (currentAttempt?.canadianRecord) {
          recordAttempt = <span>Canadian Record Attempt</span>;
        } else if (
          currentAttempt?.nationalRecord &&
          currentAttempt?.provincialRecord
        ) {
          recordAttempt = <span>Provincial and National Record Attempt</span>;
        } else if (currentAttempt?.provincialRecord) {
          recordAttempt = <span>Provincial Record Attempt</span>;
        } else if (currentAttempt?.nationalRecord) {
          recordAttempt = <span>National Record Attempt</span>;
        }

        if (!recordAttempt && recordsForAttempt && recordsForAttempt.length) {
          const firstRecord = first(recordsForAttempt);
          if (firstRecord) {
            recordAttempt = `${formatEligibleRecord({
              record: firstRecord,
            })} Record Attempt`;
            if (recordsForAttempt.length > 1) {
              recordAttempt =
                recordAttempt + ` and ${recordsForAttempt.length - 1} more...`;
            }
          }
        }
        console.log("currentAttempt", currentAttempt);
        return (
          <div style={style} className="lifter-details">
            {recordAttempt}
            {!currentAttempt?._id && "State and National Record Attempt"}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default RecordInfo;
